import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { RichTextViewComponent } from 'shared/feature-rich-text-view';
import { NamePipe } from 'shared/util-common';

import { POPOVER_DATA, User } from '@treetop/shared/model';

export type NoteDialogData = {
  title?: string | null;
  message?: string | null;
  infoData: {
    version?: string;
    approvedAt?: string;
    approvedBy?: Partial<User>;
  };
};

@Component({
  selector: 'tt-guideline-note-dialog',
  standalone: true,
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss'],
  imports: [MatIconModule, TranslocoModule, RichTextViewComponent, NamePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteDialogComponent {
  public data: NoteDialogData = inject<NoteDialogData>(POPOVER_DATA);
}
